import {doNotTrack, SEGMENT_WRITE_KEY} from './consts';
import {init, getPage, breadcrumb2userTrack, asyncCall, getExtendData} from './util';

import {callThirdParties} from './track-plugins/TrackPlugin'
import SegmentTrackPlugin from './track-plugins/SegmentTrackPlugin'
import SpendTimeTrack from "./track-plugins/SpendTimeTrack";
import PurePendoTrackPlugin from "./track-plugins/PurePendoTrackPlugin";
import { getPendoKeyByHost } from "./SdkKeyMappings";

const plugins = new Set();

function sentryPsPlugin(Raven, defMeta = {}) {

	init(Raven, defMeta);

	insertMeta({
		timestamp: Date.now() / 1000,
		action:`pageEnter ${getPage()}`,
		category: `PAGE`,
		page: getPage()
	});


	function insertMeta(metaDataOrFunction = {}) {
		asyncCall(function () {
			let meta = typeof metaDataOrFunction === 'function' ? metaDataOrFunction(): metaDataOrFunction;
			let breadcrumb = {};
			if(!meta.timestamp){
				meta.timestamp = Date.now() / 1000
			}
			Object.assign(breadcrumb, meta,{category:meta.category || 'PROGRAM'});

			Raven.captureBreadcrumb(breadcrumb);
			afterInsertMeta(breadcrumb);
		});
	}

	function afterInsertMeta(breadcrumb) {
		if(!doNotTrack){
			let trackData = breadcrumb2userTrack(breadcrumb);
			callThirdParties(trackData);
		}
	}

	Raven.insertMeta = insertMeta;
	Raven.updateIdentity = () => null;


	if (doNotTrack) {
		console.log(`Honor user's DoNotTrack config`);
	}else{

		const extendData = getExtendData() || {};
		const noUser = !extendData.account_id_cipher && !extendData.company_id_cipher;

		if(typeof defMeta.ENV_PENDO_ONLY === 'string' || noUser) {
			const env = defMeta.ENV_PENDO_ONLY ? defMeta.ENV_PENDO_ONLY.toLowerCase() : undefined;
			if(env) {
				console.log(`ENV_PENDO_ONLY: ${env}`);
				console.log(`noUser: ${noUser}`);
				console.error(`do not use ENV_PENDO_ONLY in production`)
			}
			let purePendoPlugin = new PurePendoTrackPlugin(getPendoKeyByHost());
			purePendoPlugin.init();
			plugins.add(purePendoPlugin);
		} else {
			    // 完全没用户信息不进tidb
				const segmentKey = defMeta.FORCE_SEGMENT_WRITE_KEY || SEGMENT_WRITE_KEY;
				if(segmentKey) {
					let segmentPlugin = new SegmentTrackPlugin(segmentKey);
					segmentPlugin.init();
					plugins.add(segmentPlugin);
				} else {
					console.warn('No segmentKey found')
				}

				if(defMeta.openSpendTimeTrack) {
					let spendTimeTrack = new SpendTimeTrack(getPage(), segmentKey);
					plugins.add(spendTimeTrack);
				}
		}
	}
}
sentryPsPlugin.getPlugins = function () {
	return plugins;
};

sentryPsPlugin.uninstall = function () {
};

export default sentryPsPlugin;
